import React from "react";
import {
	NumberInput,
	ReferenceInput,
	required,
	SelectInput,
	SimpleForm,
	TextInput,
} from "react-admin";

const Form = (props) => {
	return (
		<SimpleForm {...props} redirect="list">
			<ReferenceInput
				source="contest_id"
				fullWidth
				reference="contests"
				resettable
				validate={required()}
			>
				<SelectInput optionText="title" />
			</ReferenceInput>
			<TextInput source="user" validate={required()} />
			<NumberInput source="points" validate={required()} defaultValue="1" />
		</SimpleForm>
	);
};
export default Form;
